import React from "react";
import styled from "styled-components";

const Grid = styled.div`
  display: grid;
  grid-gap: 0 1em;
  grid-template-columns: repeat(${props => props.grid}, 1fr);
`;

export default function FeatureSection() {
  return (
    <section className="features-area section-gap" id="feature_block">
      <div className="container">
        <div className="text-center mb-70">
          <h1>Our Features</h1>
        </div>
        <Grid grid={2} className="mb-90">
          <div className="child-1">
            <svg
              height="100%"
              width="25%"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="paste"
              className="svg-inline--fa fa-paste fa-w-14"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                fill="#4b5f78"
                d="M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
              />
            </svg>
          </div>
          <div className="child-2">
            <h2>Online Exam</h2>
            <div className="wow fadeIn" data-wow-duration="1s">
              <p>
                Weekly exams where you can compete with other students. Exams
                are created by a professional team of teachers and toppers with
                detail explanation on the questions.
              </p>
            </div>
          </div>
        </Grid>

        <Grid grid={2} className="grid-2 mb-70">
          <div className="child-3">
            <h2>Discussion</h2>
            <div className="wow fadeIn" data-wow-duration="1s">
              <p>
                Feature rich platform to discuss about questions and other
                queries with other students as well as teachers, toppers and
                administration,
              </p>
            </div>
          </div>
          <div className="child-4">
            <svg
              aria-hidden="true"
              height="100%"
              width="25%"
              focusable="false"
              data-prefix="far"
              data-icon="comments"
              className="svg-inline--fa fa-comments fa-w-18"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
            >
              <path
                fill="#4b5f78"
                d="M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
              />
            </svg>
          </div>
        </Grid>

        <Grid grid={2} className="mb-70">
          <div className="child-5">
            <svg
              aria-hidden="true"
              height="100%"
              width="25%"
              focusable="false"
              data-prefix="far"
              data-icon="newspaper"
              className="svg-inline--fa fa-newspaper fa-w-18"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
            >
              <path
                fill="#4b5f78"
                d="M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"
              />
            </svg>
          </div>
          <div className="child-6">
            <h2>News</h2>
            <div className="wow fadeIn" data-wow-duration="1s">
              <p>
                Keep yourself up to date with the latest coverage of all the new
                happenings and events. Regularly updated with any new
                information regarding exams
              </p>
            </div>
          </div>
        </Grid>

        <Grid grid={2} className="grid-4 mb-70">
          <div className="child-7">
            <h2>Leaderboard</h2>
            <div className="wow fadeIn" data-wow-duration="1s">
              <p>
                Find out your ranking among all students. Compete to increase
                your rank and come at the top among students preparing for exam
              </p>
            </div>
          </div>
          <div className="child-8">
            <svg
              aria-hidden="true"
              height="100%"
              width="25%"
              focusable="false"
              data-prefix="fas"
              data-icon="credit-card"
              className="svg-inline--fa fa-credit-card fa-w-18"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
            >
              <path
                fill="#4b5f78"
                d="M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
              />
            </svg>
          </div>
        </Grid>
      </div>
    </section>
  );
}
